import { NavLink } from "react-router-dom";
import {
  FiGrid,
  FiBriefcase,
  FiShoppingBag,
  FiTag,
  FiTarget,
  FiUsers,
  FiLayers,
  FiChevronLeft,
  FiChevronRight,
  FiCreditCard,
  FiMessageSquare,
  FiZap,
  FiFileText,
} from "react-icons/fi";
import { useAuth } from "../contexts/AuthContext";
import { useChatContext } from "../contexts/ChatContext";
import { useCompany } from "../hooks/useCompany";
import { HiOfficeBuilding } from "react-icons/hi";

const baseNavItems = [
  { to: "/dashboard", label: "Visão geral", icon: FiGrid },
  // O item de produtos será adicionado condicionalmente abaixo
  { to: "/empresa", label: "Minha Empresa", icon: FiBriefcase },
];

const Sidebar = ({ isOpen, isCollapsed, onClose, onToggleCollapse }) => {
  const { user } = useAuth();
  const { company } = useCompany();
  const { unreadCount } = useChatContext();
  const CollapseIcon = isCollapsed ? FiChevronRight : FiChevronLeft;
  const isAdmin = user?.role === "ADMIN";
  const isPowerUser = user?.role === "POWER_USER";
  const isAdvertiser = user?.role === "ADVERTISER";
  const canAccessCompanies = ["POWER_USER", "ADMIN"].includes(user?.role);
  const shouldShowVerificationNotice = isAdvertiser && Boolean(company?.isDraft);

  // Monta os itens de navegação conforme o papel do usuário
  let navItems = [...baseNavItems];
  if (isAdmin) {
    // Admin: só mostra admin/produtos, admin/assinaturas, não mostra /produtos
    navItems = navItems.filter((item) => item.to !== "/empresa");
    navItems.push({
      to: "/admin/produtos",
      label: "Produtos",
      icon: FiShoppingBag,
    });

    navItems.push({
      to: "/admin/categorias",
      label: "Categorias",
      icon: FiTag,
    });
    if (canAccessCompanies) {
      navItems.push({
        to: "/empresas",
        label: "Empresas",
        icon: HiOfficeBuilding,
      });
      navItems.push({
        to: "/admin/clientes",
        label: "Clientes",
        icon: FiUsers,
      });
    }
    navItems.push({
      to: "/admin/assinaturas",
      label: "Assinaturas",
      icon: FiCreditCard,
    });
  } else if (isPowerUser) {
    // Power user revisa o catálogo: mesma fila do admin, sem as telas de billing.
    navItems = navItems.filter((item) => item.to !== "/empresa");
    navItems.push({
      to: "/admin/produtos",
      label: "Produtos",
      icon: FiShoppingBag,
    });
    navItems.push({
      to: "/empresas",
      label: "Empresas",
      icon: HiOfficeBuilding,
    });
    navItems.push({
      to: "/admin/clientes",
      label: "Clientes",
      icon: FiUsers,
    });
  } else if (isAdvertiser) {
    // Anunciante: só mostra /produtos e Assinatura, não mostra admin/produtos
    navItems.splice(1, 0, {
      to: "/produtos",
      label: "Produtos",
      icon: FiShoppingBag,
    });
    navItems.splice(2, 0, {
      to: "/assinatura",
      label: "Assinatura",
      icon: FiCreditCard,
    });
    // navItems.splice(3, 0, {
    //   to: "/servicos",
    //   label: "Serviços",
    //   icon: FiZap,
    // });
    navItems.splice(4, 0, {
      to: "/faturas",
      label: "Faturas",
      icon: FiFileText,
    });
    navItems.push({
      to: "/chat",
      label: "Chat",
      icon: FiMessageSquare,
    });
  }

  return (
    <aside
      className={`sidebar ${isOpen ? "sidebar--open" : ""} ${
        isCollapsed ? "sidebar--collapsed" : ""
      }`}
    >
      <div className="sidebar__header">
        <div className="brand">
          <div className="ml-2">
            <strong>Shopalli</strong>
            <span>{isAdmin || isPowerUser ? "Painel admin" : "Painel anunciante"}</span>
          </div>
        </div>
        <button
          className="icon-button sidebar__collapse !bg-black"
          onClick={onToggleCollapse}
          aria-label={isCollapsed ? "Expandir menu" : "Recolher menu"}
        >
          <CollapseIcon />
        </button>
      </div>
      <nav className="sidebar__nav">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isChat = item.to === "/chat";
          const showBadge = isChat && unreadCount > 0;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onClose}
              className={({ isActive }) => (isActive ? "active" : "")}
              style={{ position: "relative" }}
            >
              <Icon />
              <span className="sidebar__label">{item.label}</span>
              {showBadge && (
                <span
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: isCollapsed ? 6 : 12,
                    transform: "translateY(-50%)",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span className="chat-badge-ping" />
                  <span className="chat-badge-dot">
                    {unreadCount > 9 ? "9+" : unreadCount}
                  </span>
                </span>
              )}
            </NavLink>
          );
        })}
      </nav>

      <>
        <div className="sidebar__footer text-center">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "0.6rem",
              marginBottom: "0.4rem",
            }}
          >
            <img
              src="/assets/logo_branco.png"
              alt="Shopalli"
              style={{ width: "64px", height: "auto", objectFit: "contain" }}
            />
          </div>
          {shouldShowVerificationNotice ? (
            <div>
              Complete o cadastro da empresa para ganhar o selo de verificado.
            </div>
          ) : null}
        </div>
      </>
    </aside>
  );
};

export default Sidebar;
